







































import { Vue, Component, Watch } from 'vue-property-decorator';
import { getRank } from '../api';
import { List } from 'vant';
import { nextTick, watch } from 'vue';
Vue.use(List);
@Component
export default class Rank extends Vue {
  show: boolean = true;
  list: any[] = [];
  activity: number = 1;
  page = 1;
  loading = false;
  finished = false;
  isexit = false;
  loadingStatus = true;
  refreshing: boolean = false;
  tab: any[] = [
    {
      text: '小学组',
      default: require('../assets/标题背景.png'),
      activity: require('../assets/激活标题背景.png'),
    },
    {
      text: '中学组',
      default: require('../assets/标题背景.png'),
      activity: require('../assets/激活标题背景.png'),
    },
    {
      text: '总排行',
      default: require('../assets/标题背景.png'),
      activity: require('../assets/激活标题背景.png'),
    },
  ];
  onLoad() {
    if (this.isexit) {
      return; // 如果请求已经在进行中，则不进行新的请求
    }
    this.isexit = true;
    getRank(this.activity, this.page)
      .then((res: any) => {
        this.endListData(res);
      })
      .finally(() => {
        this.isexit = false;
      });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].title) {
            this.list.push(res.data[i]);
          }
        }
        this.loading = false;
      } else {
        this.finished = true;
      }
    }
  }
  @Watch('activity')
  onactivityChanged() {
    this.finished = true;
    setTimeout(() => {
      this.list = [];
      this.page = 1;
      this.finished = false;
      this.loading = false;
      this.show = true;
    }, 150);
  }
  changeTab(index: number) {
    if (this.activity === index + 1) {
      return;
    }
    if (this.isexit) {
      return;
    }
    this.show = false;
    this.activity = index + 1;
    setTimeout(() => {
      this.show = true;
    }, 150);
  }
}
